import { render, staticRenderFns } from "./StudentNotice.vue?vue&type=template&id=4807601e"
import script from "./StudentNotice.vue?vue&type=script&lang=js"
export * from "./StudentNotice.vue?vue&type=script&lang=js"
import style0 from "./StudentNotice.vue?vue&type=style&index=0&id=4807601e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports